import {Component, HostListener, Input} from '@angular/core';
import {Message} from '../../../contracts/message.interface';
import {DatePipe, NgIf} from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-message-image',
  imports: [NgIf, DatePipe],
  templateUrl: './message-image.component.html',
  styleUrl: './message-image.component.scss',
})
export class MessageImageComponent {
  @Input() message!: Message;

  previewVisible = false;
  scale = 1;

  get messageDateFormat(): string {
    const d = new Date(this.message?.creationDate as string | number | Date);
    if (!this.message?.creationDate || isNaN(d.getTime())) return 'HH:mm';
    const today = new Date();
    return d.getFullYear() === today.getFullYear() &&
           d.getMonth() === today.getMonth() &&
           d.getDate() === today.getDate() ? 'HH:mm' : 'dd/MM/yyyy HH:mm';
  }

  openPreview() {
    this.previewVisible = true;
    this.scale = 1;
  }

  closeOnBackdrop(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('preview-overlay')) {
      this.previewVisible = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    if (this.previewVisible) {
      this.previewVisible = false;
    }
  }

  zoomIn() {
    this.scale = Math.min(this.scale * 1.25, 5);
  }

  zoomOut() {
    this.scale = Math.max(this.scale / 1.25, 0.2);
  }

  reset() {
    this.scale = 1;
  }
}
